import { render } from "./DefaultHeader.vue?vue&type=template&id=ef67fa2c&scoped=true"
import script from "./DefaultHeader.vue?vue&type=script&lang=js"
export * from "./DefaultHeader.vue?vue&type=script&lang=js"

import "./DefaultHeader.scss?vue&type=style&index=0&id=ef67fa2c&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef67fa2c"]])

export default __exports__